import { createContext, useContext } from 'react'
import { MapRef } from 'react-map-gl/mapbox'

export type MapContextValue = {
  mapRef?: MapRef
}

export const MapContext = createContext<MapContextValue>({})

export const useMapContext = () => useContext<MapContextValue>(MapContext)
